export const enterpriseSsoPathname = '/enterprise-sso';
export const invalidConfigErrorCode = 'connector.invalid_config';
export const invalidMetadataErrorCode = 'connector.invalid_metadata';
